import React from 'react';
import ModalWrapper from '../ModalWrapper';
import ModalInactivity from './ModalInactivity';


const ModalInactiveUser = ({isOpen, onCloseModal}) => (
    <ModalWrapper isOpen={isOpen} cssClass="modal-inactivity">
        <ModalInactivity onCloseModal={onCloseModal} />
    </ModalWrapper>
);

export default ModalInactiveUser;